package br.com.vvrefeicoes.portal.domain.model

data class SatisfactionCompany(
    val id: String,
    val name: String,
    val active: Boolean,
    val buttonCount: Int,
    val employeeCount: Double = 0.0,
    val services: List<SatisfactionCompanyService> = emptyList(),
)

data class SatisfactionCompanyService(
    val typeId: String = "",
    val name: String = "",
    val active: Boolean = true,
    val dailyQuantity: Double = 0.0,
    val activeDaysByMonth: Map<String, List<Int>> = emptyMap(),
)

data class SatisfactionDailyVotes(
    val date: String,
    val excellent: Int,
    val good: Int,
    val regular: Int,
    val poor: Int,
    val total: Int,
)

data class SatisfactionServiceVotes(
    val name: String,
    val total: Int,
    val ratings: Map<String, Int>,
    val percentages: Map<String, Double> = emptyMap(),
    val typeId: String = "",
    val startTime: String = "",
    val endTime: String = "",
    val dailyQuantity: Double = 0.0,
    val activeDaysByMonth: Map<String, List<Int>> = emptyMap(),
)

data class NegativeSatisfactionVote(
    val rating: String,
    val comment: String,
    val date: String,
    val serviceName: String,
)

data class SatisfactionReport(
    val totalVotes: Int,
    val ratings: Map<String, Int>,
    val percentages: Map<String, Double>,
    val dailyVotes: List<SatisfactionDailyVotes>,
    val serviceVotes: List<SatisfactionServiceVotes>,
    val negativeVotes: List<NegativeSatisfactionVote>,
    val recentVotes: List<NegativeSatisfactionVote> = emptyList(),
)

data class SatisfactionMetric(
    val count: Int,
    val percentage: Double,
)

data class OperationStatus(
    val totalVotes: Int,
    val satisfaction: SatisfactionMetric,
    val improvement: SatisfactionMetric,
)

data class SatisfactionRankingItem(
    val position: Int,
    val companyId: String,
    val companyName: String,
    val dailyMeals: Double,
    val totalVotes: Int,
    val satisfaction: SatisfactionMetric,
    val improvement: SatisfactionMetric,
)
